import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * This service is responsible for enabling or disabling the "REPEAT_ACTION_BLK_ADT" feature.
 */
@Injectable()
export class RepeatActionBlkAdt implements IFlagFeature {
  name = Features.REPEAT_ACTION_BLK_ADT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
